import { Dialog } from "radix-ui";
import Text from "../../molecules/content/Text";

export default function DialogTitle({ title }) {
  return (
    <Dialog.Title className={`${title ? "pt-4" : ""}`}>
      <Text variant="h2" className="text-vestelColor">
        {title}
      </Text>
    </Dialog.Title>
  );
}
